export const firebaseErrorMap = {
  "APIError: Email address already in use. Please try to log in.":
    "Email address already in use, please try to log in.",
  "APIError: Firebase token verification failed: User not found in backend. Please sign up first.":
    "User not found. Please sign up first.",
  "Email address already in use. Please try to log in.":
    "Email address already in use, please try to log in.",
  "Login Failed: Firebase: Error (auth/account-exists-with-different-credential).":
    "You may already have an account with that email address, please try logging in with the original method you used to sign up.",
  "Organization has reached its maximum number of seats":
    "This organization has reached its maximum number of seats. Please contact your organization admin.",
  "Firebase: Error (auth/invalid-credential).":
    "Invalid credentials. Please check your password and try again.",
  "Firebase: Error (auth/wrong-password).":
    "Invalid credentials. Please check your password and try again.",
  "Firebase: Error (auth/requires-recent-login).":
    "For security reasons, please log out and log back in before changing your email.",
  "Firebase: Error (auth/email-already-in-use).":
    "This email is already in use by another account.",
  "Firebase: Error (auth/invalid-email).": "The email address is not valid.",
  "Firebase: Error (auth/user-token-expired).":
    "Your session has expired. Please log in again.",
  "No account found. Please sign up first.":
    "No account found with this email. Please sign up first.",
  "Please wait a few minutes and try again.":
    "A temporary account conflict was detected. Please wait a few minutes and try again.",
  "Firebase: Error (auth/too-many-requests).":
    "Too many failed attempts. Please wait a moment and try again.",
  "Firebase: Error (auth/popup-closed-by-user).":
    "Sign-in was cancelled. Please try again.",
  "Firebase: Error (auth/weak-password).":
    "Password is too weak. Please use at least 8 characters and at least 1 special character.",
  "Firebase: Error (auth/user-disabled).":
    "This account has been disabled. Please contact support.",
  "Invalid invitation code":
    "Invalid invitation code. Please check your link and try again.",
  "Invitation has expired": "This invitation has expired.",
  "Invitation has reached its maximum number of uses":
    "This invitation has reached its maximum number of uses.",
  "Invitation is inactive": "This invitation is no longer active.",
  "Account creation failed. Please try again.":
    "Account creation failed. Please try again.",
  "Invalid Firebase token":
    "Your session is invalid. Please refresh the page and try again.",
  "Firebase token has expired":
    "Your session has expired. Please refresh the page and try again.",
  "Authentication failed": "Authentication failed. Please try again.",
};

export const formatFirebaseError = (error: string) => {
  const errorMessageIndex = Object.keys(firebaseErrorMap).findIndex((key) =>
    key.includes(error)
  );

  if (errorMessageIndex !== -1) {
    return Object.values(firebaseErrorMap)[errorMessageIndex];
  }

  console.error("Unhandled error:", error);

  return "An error occurred. Please try again.";
};
